<template>
	<div style="overflow-y: scroll;height: 100%;">
		<div class="top">
			<a-button type="primary" @click="writeDaily"> 写日报 </a-button>
		</div>
		<div class="top">
			<span @click="got" :class="boo==1?'goinact':'goin'">我收到的</span>
			<span @click="initiated" :class="boo==0?'goinact':'goin'">我发出的</span>
			<a-input allowClear class="a_input_self margin_self" placeholder="姓名" v-if="boo==1" v-model='userName' @change="changequery" @keyup.enter.native="query"/>
			<a-range-picker valueFormat="YYYY-MM-DD" style="margin-right: 10px; width: 220px" allowClear :value="dates" @change="onChange" @keyup.enter.native="query"
			 :placeholder="['开始日期', '结束日期']" />
			<a-select show-search allowClear placeholder="未读" class="margin_self" style="width: 120px" v-if="boo==1" v-model="isRead" @keyup.enter.native="query"
			 @change="changequery">
				<a-select-option :value="index" v-for="(item, index) in rnr" :key="index">
					{{ item }}
				</a-select-option>
			</a-select>
			<a-button type="primary" @click="query"> 查询 </a-button>
			<a-button type="primary" ghost @click="result"> 重置 </a-button>
		</div>
		<div class="back">
			<div class="left" v-if="boo==1">
				<div v-for="(item,index) in dailydata" :key="index" :class="activeIndex == index?'active':'itemDay'" @click="act(index)">
					{{item.userName}}的日报 &nbsp<div class="tip" v-if="item.isRead=='0'"></div>
				</div>
			</div>
			<div class="left" v-if="boo==0">
				<div v-for="(item,index) in dailydata2" :key="index" :class="activeIndex == index?'active':'itemDay'" @click="act(index)">
					{{item.createTime.replace('-', '年').replace('-', '月').slice(0,10)+'日'+item.createTime.slice(10)}}
				</div>
			</div>
			<div class="content bg" v-if="Object.keys(actdata)==0">
				
			</div>
			<div class="content" v-else>
				<div class="item">
					<div class="title" v-if="boo==1">
						{{actdata.userName}}的日报
					</div>
					<div class="title" v-if="boo==0">
						我的日报
					</div>
					<div class="time">
						{{actdata.createTime}}
					</div>
					<div class="cont">
						今日完成工作:
					</div>
					<div v-html="actdata.finishWork.replace(/\n/g,'<br/>')" class="ent" v-if="boo==1">
					</div>
					<a-textarea class="ent" :auto-size="{ minRows: 10, maxRows: 10 }" v-model="actdata.finishWork" v-if="boo==0"></a-textarea>
					<div class="cont">
						未完成工作:
					</div>
					<div v-html="actdata.unfinishedWork.replace(/\n/g,'<br/>')" class="ent" v-if="boo==1">
					</div>
					<a-textarea class="ent" :auto-size="{ minRows: 5, maxRows: 10 }" v-model="actdata.unfinishedWork" v-if="boo==0"></a-textarea>
					<div class="cont">
						需协调工作:
					</div>
					<div v-html="actdata.needToCoordinate.replace(/\n/g,'<br/>')" class="ent" v-if="boo==1">
					</div>
					<a-textarea class="ent" :auto-size="{ minRows: 5, maxRows: 10 }" v-model="actdata.needToCoordinate" v-if="boo==0"></a-textarea>
					<div class="cont">
						明日待办工作:
					</div>
					<div v-html="actdata.toDo.replace(/\n/g,'<br/>')"  class="ent" v-if="boo==1">
					</div>
					<a-textarea class="ent" :auto-size="{ minRows: 5, maxRows: 10 }" v-model="actdata.toDo" v-if="boo==0"></a-textarea>
					<div class="cont">
						备注:
					</div>
					<div v-html="actdata.remark.replace(/\n/g,'<br/>')" class="ent" v-if="boo==1">
					</div>
					<a-textarea class="ent" :auto-size="{ minRows: 5, maxRows: 10 }" v-model="actdata.remark" v-if="boo==0"></a-textarea>
					<a-button type="primary" @click="save" v-if='boo==0'> 提交 </a-button>
				</div>
			</div>
			
		</div>
		<a-modal title="写日报" :visible="visible" @ok="handleOk" @cancel="handleCancel" :maskClosable="false" width='60%'>
			<div>
				今日完成工作:
				<textarea class="dayOk" v-model="info.finishWork">
				</textarea>
			</div>
			<div>
				未完成工作:
				<textarea class="dayOk" v-model="info.unfinishedWork">
				</textarea>
			</div>
			<div>
				需协调工作:
				<textarea class="dayOk" v-model="info.needToCoordinate">
				</textarea>
			</div>
			<div>
				明日待办工作:
				<textarea class="dayOk" v-model="info.toDo">
				</textarea>
			</div>
			<div>
				备注:
				<textarea class="dayOk" v-model="info.remark">
				</textarea>
			</div>
			<div class="cc">
				选择抄送人:
				<ccChange :data="ccC" @targetKeys="getdata" v-if="isRouterAlive" style="margin-top: 10px;" />
			</div>
		</a-modal>
	</div>
</template>

<script>
	import {
		daily_receiver_daily,
		daily_info,
		daily_info_post,
		daily_list,
		daily_read,
		daily_info_put,
	} from '@/api/administrative'
	import ccChange from '@/components/module/ccChange'
	export default {
		components: {
			ccChange
		},
		data() {
			return {
				ccC: '',
				visible: false,
				info: {
					finishWork: '',
					unfinishedWork: '',
					needToCoordinate: '',
					toDo: '',
					remark: '',
				},
				cc: [],
				isRouterAlive: true,
				activeIndex: -1,
				dailydata: [],
				dailydata2: [],
				actdata: {},
				boo: 1,
				isRead: undefined,
				userName: '',
				startTime: '',
				endTime: '',
				dates: [],
				isquery: 0,
			};
		},
		created() {
			this.daily3()
		},
		methods: {
			changequery() {
				this.isquery = 0
			},
			save() {
				daily_info_put(this.actdata).then(res => {
					if (res.code == 200) {
						this.$message.success('保存编辑成功')
					}
				})
			},
			result() {
				this.dates = []
				this.startTime = ''
				this.endTime = ''
				this.userName = ''
				this.isRead = undefined
			},
			onChange(date, dateString) {
				this.dates = date
				this.startTime = date[0]
				this.endTime = date[1]
				this.isquery = 0
			},
			list() {
				daily_list({
					startTime: this.startTime,
					endTime: this.endTime ? this.endTime + ' 23:59:59' : '',
				}).then(res => {
					this.dailydata2 = res.data
					this.actdata = this.dailydata2[0]
				})
			},
			list2() {
				daily_list({
					startTime: this.startTime,
					endTime: this.endTime ? this.endTime + ' 23:59:59' : '',
				}).then(res => {
					this.dailydata2 = res.data
				})
			},
			got() {
				this.boo = 1
				this.activeIndex = 0
				this.result()
				this.daily()
			},
			initiated() {
				this.boo = 0
				this.activeIndex = 0
				this.result()
				this.list()
			},
			query() {
				this.isquery = 1
				if (this.boo == 1) {
					this.daily2()
				} else if (this.boo == 0) {
					this.list2()
				}
			},
			daily() {
				this.actdata = {}
				daily_receiver_daily({
					startTime: this.startTime,
					endTime: this.endTime ? this.endTime + ' 23:59:59' : '',
					userName: this.userName,
					isRead: this.isRead
				}).then(res => {
					this.dailydata = res.data
					var id = this.dailydata[0].dailyId
					daily_info({
						id: id
					}).then(res => {
						this.actdata = res.data
						this.actdata.userName = this.dailydata[0].userName
						console.log(this.actdata)
					})
					this.read(this.dailydata[0].id)
				})
			},
			daily2() {
				daily_receiver_daily({
					startTime: this.startTime,
					endTime: this.endTime ? this.endTime + '23:59:59' : '',
					userName: this.userName,
					isRead: this.isRead
				}).then(res => {
					this.dailydata = res.data
				})
			},
			daily3() {
				daily_receiver_daily().then(res => {
					this.dailydata = res.data
					console.log(this.actdata,12)
				})
			},
			read(id) {
				if (this.isquery == 1) {
					daily_read({
						id: id
					}).then(res => {
						if (res.code == 200) {
							this.daily2()
						}
					})
				} else if (this.isquery == 0) {
					daily_read({
						id: id
					}).then(res => {
						if (res.code == 200) {
							this.daily3()
						}
					})
				}
			},
			act(idx) {
				this.activeIndex = idx
				if (this.boo == 1) {
					var id = this.dailydata[idx].dailyId
					this.read(this.dailydata[idx].id)
					daily_info({
						id: id
					}).then(res => {
						this.actdata = res.data
						this.actdata.userName = this.dailydata[idx].userName
					})
				} else if (this.boo == 0) {
					this.actdata = this.dailydata2[idx]
				}
			},
			getdata(data) {
				this.cc = data
			},
			writeDaily() {
				this.info={
					finishWork: '',
					unfinishedWork: '',
					needToCoordinate: '',
					toDo: '',
					remark: '',
				}
				this.isRouterAlive = false
				this.$nextTick(() => {
					this.isRouterAlive = true
				})
				this.visible = true;
			},
			handleOk() {
				var dailyUser = []
				this.cc.forEach(item => {
					dailyUser.push({
						receiver: item
					})
				})
				this.info['dailyUser'] = dailyUser
				daily_info_post(this.info).then(res => {
					if (res.code == 200) {
						this.visible = false;
						this.$message.success('提交日报成功')
						this.daily()
					} else {
						this.$message.error(res.msg)
					}
				})

			},
			handleCancel() {
				this.visible = false;
			},
		},
	};
</script>

<style>
	.tip {
		display: inline-block;
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background-color: red;
		margin-bottom: 1px;
	}

	.top {
		margin-bottom: 10px;
	}

	.back {
		display: flex;
	}

	.dayOk {
		display: block;
		width: 100%;
		border: 2px solid rgb(236, 236, 236);
		min-height: 10vh;
		margin: 10px 0;
	}

	.left {
		width: 12%;
		padding-left: 10px;
		border: 1px solid rgb(245, 245, 245);
	}

	.itemDay {
		border-radius: 5px;
		background-color: rgb(245, 245, 245);
		margin: 10px 10px 10px 0;
		padding: 5px;
		cursor: pointer;
	}

	.active {
		margin: 10px 10px 10px 0;
		padding: 5px;
		border-radius: 5px;
		background-color: #D2E3FE;
		color: rgb(56, 130, 248);
		cursor: pointer;
	}
	div.itemDay:hover{
		background-color:#e2eaf9;
	}
	.content {
		width: 90%;
		height: 100vh;
		padding: 10px 40px 0px 15px;
		background-color: rgb(245, 245, 245)
	}
	.bg{
		background: url(../../../public/noba.svg) no-repeat;
		background-position: center center;
	}

	.content .item {
		background-color: white;
		padding: 20px 100px;
		height: 100vh;
	}

	.content .item .title {
		font-weight: 700;
		font-size: 16px;
	}

	.content .item .time {
		font-size: 14px;
		color: rgb(186, 186, 186);
		margin-bottom: 20px;
	}

	.content .item .cont {
		font-weight: 700;
		font-size: 14px;
	}

	.content .item .ent {
		font-size: 14px;
		width: 100%;
		margin-bottom: 20px;
	}

	.goin {
		padding: 5px;
		border: 1px solid rgb(221, 223, 222);
		margin-right: 10px;
	}

	.goinact {
		padding: 5px;
		color: rgb(109, 147, 156);
		border: 1px solid rgb(109, 147, 156);
		margin-right: 10px;
	}
</style>
